import { useQuery } from 'src/graphql';
import { CAP_FINDINGS_QUERY } from 'src/graphql/cap/query';

export default jobIds =>
  useQuery(CAP_FINDINGS_QUERY, {
    variables: { jobIds },
    fetchPolicy: 'network-only',
  });
